<template>
  <vx-card>
    <!-- Head -->
    <div class="flex justify-between items-center">
      <h4>신규 사업장 등록 요청</h4>
      <div class="flex">
        <vs-button class="ml-4" color="secondary" type="border" @click="onClickMoveList">목록</vs-button>
        <vs-button class="ml-4" color="secondary" @click="onClickSave">저장</vs-button>
      </div>
    </div>

    <!-- 기본정보 -->
    <div>
      <p class="title mt-5 mb-5">기본정보</p>
      <div class="w-full grid" style="grid-template-columns: 1fr 1fr 1fr; column-gap: 1.5rem">
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">분야명</div>
          <ml-input class="w-full flex-1" v-model="projectInfo.field_name" placeholder="자동입력" readonly />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">소속명</div>
          <ml-input class="w-full flex-1" v-model="myInfo.department" placeholder="자동입력" readonly />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">부서명</div>
          <ml-input class="w-full flex-1" v-model="myInfo.section" placeholder="자동입력" readonly />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">직책</div>
          <ml-input class="w-full flex-1" v-model="companyInfo.director" placeholder="자동입력" readonly />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">작성자</div>
          <ml-input class="w-full flex-1" v-model="myInfo.name" placeholder="자동입력" readonly />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">작성일</div>
          <date-selector class="w-full flex-1" :value="today" placeholder="자동입력" readonly />
        </div>
      </div>
    </div>

    <!-- 신규 사업장 개요 -->
    <div>
      <p class="title mt-5 mb-5">신규 사업장 개요</p>
      <div class="w-full grid" style="grid-template-columns: 1fr 1fr 1fr; column-gap: 1.5rem">
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">사업장명</div>
          <ml-input class="w-full flex-1" v-model="form.field_name" placeholder="입력필드" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">담당 주무관</div>
          <ml-input class="w-full flex-1" v-model="form.director_name" placeholder="입력필드" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">사업기간</div>
          <div class="flex items-center gap-3">
            <date-selector v-model="form.work_begin_at" class="w-full flex-1" placeholder="선택" />
            <span>~</span>
            <date-selector v-model="form.work_end_at" class="w-full flex-1" placeholder="선택" />
          </div>
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">사업금액</div>
          <ml-input class="w-full flex-1" v-model="form.deposit_amount" placeholder="입력필드" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">사업장 주소</div>
          <ml-input class="w-full flex-1" v-model="form.address" placeholder="입력필드" />
        </div>
        <div class="mb-4" style="display: grid; grid-template-columns: 116px 1fr; align-items: center">
          <div class="label-text mr-4">사업장 연락처</div>
          <ml-input class="w-full flex-1" v-model="form.phone" placeholder="입력필드" />
        </div>
      </div>
    </div>

    <!-- 수급업체 정보 -->
    <FieldWorkplaceTable v-model="infoDatas" />
  </vx-card>
</template>

<script>
import moment from "moment";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FieldWorkplaceTable from "./components/FieldWorkplaceTable.vue";

import FileInput from "@/components/custom/FileInput";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FileUploader from "@/components/FileUploader";
import CompanyAddModule from "@/views/_BS/components/CompanyAddModule";
import CompanyUserAuthModule from "@/views/_BS/components/CompanyUserAuthModule";
import SearchNavStartEnd from "@/views/list/components/SearchNavStartEnd";
import DateSelector from "@/components/selector/DateSelector";

export default {
  components: {
    FieldSelectModule,
    FieldWorkplaceTable,

    DateSelector,
    SearchNavStartEnd,
    CompanyUserAuthModule,
    CompanyAddModule,
    FileUploader,
    FileInput,
    FileUploadModule,
  },
  data() {
    return {
      form: {
        field_name: "", // 사업장명
        director_name: "", // 담당 주무관
        work_begin_at: "", // 사업기간 시작
        work_end_at: "", // 사업기간 종료
        deposit_amount: "", // 사업금액
        address: "", //사업장 주소
        phone: "", // 사업장 연락처
      },

      infoDatas: [],
      infoSelected: [],
      expandSelected: [],
    };
  },
  computed: {
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    companyInfo() {
      return this.$store.state.auth.companyInfo;
    },
    projectInfo() {
      return this.$store.state.project.projectInfo;
    },
    postId() {
      return this.$route.params.postId;
    },
    today() {
      return moment(new Date()).format("YYYY-MM-DD");
    },
  },
  created() {
    this.initBreadcrumb();
  },
  mounted() {
    if (this.postId) this.loadField();
  },
  methods: {
    initBreadcrumb() {
      this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "신규 사업장 등록 요청" }, { title: "도급·용역·위탁 사업장", active: true }]);
    },
    async loadField() {
      const postId = this.postId;
      await this.$store.dispatch("project/LOAD_FIELD", { postId });
      const info = this.$store.state.project.fieldInfo;
      this.form = { ...info };

      if (this.form.field_map.length > 0) {
        this.form.field_map = this.form.field_map[0];
      } else {
        this.form.field_map = {};
      }
      if (this.form.field_photo.length > 0) {
        this.form.field_photo = this.form.field_photo[0];
      } else {
        this.form.field_photo = {};
      }
      if (this.form.field_view.length > 0) {
        this.form.field_view = this.form.field_view[0];
      } else {
        this.form.field_view = {};
      }

      if (this.form.companies && this.form.companies.length > 0) {
        const companies = [];
        for (const company of this.form.companies) {
          companies.push(company);
        }

        await this.initMembers();
      }
    },
    onClickSave() {
      const company_ids = [];

      const user_ids = [];

      this.form.company_ids = company_ids;
      this.form.user_ids = user_ids;
      this.form.project_id = this.$route.params.proj_id;

      if (this.postId) {
        // update
        const fieldId = this.postId;
        this.$store
          .dispatch("project/UPDATE_FIELD", {
            field_type: "사업장(용역위탁)",
            fieldId,
            ...this.form,
          })
          .then((/*value*/) => {
            this.$router.back();
          });
      } else {
        // create
        this.$store
          .dispatch("project/CREATE_FIELD", {
            field_type: "사업장(용역위탁)",
            ...this.form,
          })
          .then((/*value*/) => {
            this.$router.back();
          });
      }
    },
    onClickMoveList() {
      this.$router.push({ name: "ep-field-workplace2-list" });
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 18px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0px;
    border-radius: 100%;
  }

  & > span {
    color: #696d71;
  }
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
</style>
